import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=a5dccb86&scoped=true"
import script from "./particulars.vue?vue&type=script&lang=js"
export * from "./particulars.vue?vue&type=script&lang=js"
import style0 from "./particulars.vue?vue&type=style&index=0&id=a5dccb86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dccb86",
  null
  
)

export default component.exports